export default __webpack_public_path__ + "static/media/icecream@2x.116dda6e.jpg";